import { CSS } from "@stitches/react";
import { BoxProps } from "../Box";
import { Container } from "../Container";

export type AppBarContainerProps = {
  children: React.ReactNode;
  css: CSS;
};

export const AppBarContainer = ({ children, css }: BoxProps) => {
  const currentUrl = window.location.href;
  const path = currentUrl.split("/").at(4);
  return (
    <Container
      css={{
        py: "$4",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "$6",
        minHeight: "5.5rem",
        "@mxlg": {
          px: "$5",
          ta: path === "empresas" ? "start" : "center",
        },
        ...css,
      }}
    >
      {children}
    </Container>
  );
};

AppBarContainer.displayName = "AppBarContainer";
